import { render, staticRenderFns } from "./CorporateValues.vue?vue&type=template&id=16d4e8aa&scoped=true&"
import script from "./CorporateValues.vue?vue&type=script&lang=js&"
export * from "./CorporateValues.vue?vue&type=script&lang=js&"
import style0 from "./CorporateValues.vue?vue&type=style&index=0&id=16d4e8aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d4e8aa",
  null
  
)

export default component.exports